import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SwitchBox } from '../../molecules/switch-box';
import { ParentPaper } from '../../atoms/parent-paper';
import { HelpButton } from '../../atoms/help-button';
import { SpotPricePeriodSelect } from '../spot/spot-price-period-select';
import { SpotRegionSelect } from '../spot/spot-region-select';
import { SettingsSpBatteryCharge } from '../../templates/settings/boxes/settings-sp-battery-charge';
import { SettingsSpBatteryDischargePrevent } from '../../templates/settings/boxes/settings-sp-battery-discharge-prevent';
import { SettingsSpOverflow } from '../../templates/settings/boxes/settings-sp-overflow';
import { SettingsSpBatteryToGrid } from '../../templates/settings/boxes/settings-sp-battery-to-grid';

export const SpotSettingsUser = () => {
  return (
    <>
      <ParentPaper>
        <SpotRegionSelect />
        <SpotPricePeriodSelect />
      </ParentPaper>

      <SettingsSpBatteryCharge />

      <ParentPaper>
        <SwitchBox
          title={
            <>
              <FormattedMessage
                id="settings.spot.battery.stop_discharge_auto"
                defaultMessage="Automatické řízení zákazu vybíjení"
              />
              <HelpButton
                variant="dialog"
                title={
                  <FormattedMessage
                    id="settings.spot.battery.stop_discharge_auto"
                    defaultMessage="Automatické řízení zákazu vybíjení"
                  />
                }
                content={
                  <FormattedMessage
                    id="settings.spot.battery.stop_discharge_auto.help"
                    defaultMessage="Pokud zvolíte tuto možnost, tak systém automaticky bude řídit vybíjení baterie a povolí ho pouze při nejvyšších denních cenách na spotu."
                  />
                }
              />
            </>
          }
          switchVariableId="SP_BATTERY_STOP_DISCHARGE_AUTO"
          subtitle={
            <FormattedMessage
              id="settings.spot.battery.stop_discharge_auto.subtitle"
              defaultMessage="Řízení uschová energii automaticky na nejdražší hodiny."
            />
          }
          visibility={{
            variableIds: [
              'SP_INSTALL',
              'PV_BATTERY',
              'SP_BATTERY_STOP_DISCHARGE_AUTO_DEV',
              'PV_BATTERY_CONTROL',
            ],
          }}
          fullWidth
        />

        <SettingsSpBatteryDischargePrevent />
      </ParentPaper>

      <SettingsSpOverflow />

      <SettingsSpBatteryToGrid />
    </>
  );
};
